import {Routes} from '@angular/router';
import {MsAuthComponent} from './component';

export const MsAuthRoutes: Routes = [
    {
        path: 'msal-auth',
        component: MsAuthComponent
    }
];
